<template>
  <div class="editable-cell" :data-type="dataType">
    <a-time-picker
      v-if="type === 'time-picker'"
      :format="DATE_FORMAT_HM"
      :disabled="!editable"
      :value="formatStringToDate(text, DATE_FORMAT_HM)"
      @change="handleChange"
    />
    <a-checkbox v-else-if="type === 'checkbox'" :checked="text" @change="handleChange" />
    <a-input v-else :value="text" @change="handleChange" :disabled="!editable" />
  </div>
</template>

<script>
import { DATE_FORMAT_HM, formatStringToDate } from "@/utils";
export default {
  name: "EditableCell",
  props: {
    text: {
      type: [String, Boolean, Object],
    },
    type: {
      type: String,
      default: "input",
    },
    editable: {
      type: Boolean,
      default: true,
    },
    dataType: {
      type: String,
    },
  },
  data() {
    return {
      DATE_FORMAT_HM,
    };
  },
  methods: {
    formatStringToDate,
    handleChange(e) {
      let value = "";

      switch (this.type) {
        case "input": {
          value = e.target.value;
          break;
        }
        case "checkbox": {
          value = e.target.checked;
          break;
        }
        default: {
          value = e;
        }
      }
      this.$emit("change", value);
    },
  },
};
</script>
